import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid } from '@mui/material';

import { PageContainer, FilterPod, TableComponents, ButtonLoading, SimpleDialog } from 'components';
import { useQuery, useCurrencyUnit } from 'hooks';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { columns, generateData } from './components/Columns';
import SubsetServices from '../../Subsets/services/SubsetServices';
import Services from '../services';
import { getCredit } from './hooks/hook';
import useCustomHook from './hooks';
import { useStyles } from './style';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';

export default function CartableRequestList() {
  //-- STATES --//
  const queryq = useQuery();
  let tableRef = useRef();
  const {
    loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    filters,
    setFilters,
    loadingBtn,
    setLoadingBtn,
    dialog,
    setDialog,
    page,
    setPage,
  } = useCustomHook();
  //--HOOKS--//
  const classes = useStyles();
  const currencyText = useCurrencyUnit(false);

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const actionsList = getDynamicObjectAction([
    'contentRequestCartblePage',
    'requestsGuildBtn',
    'CancelRequestCartbleBtn',
    'detailsRequestCartbleBtn',
    'detailRequestsGuildBtn',
    'cancelRequestsGuildBtn',
  ]);
  const navigate = useNavigate();
  useEffect(() => {
    if (actionsList['contentRequestCartblePage'] || actionsList['requestsGuildBtn']) {
      getCredit();
    }
  }, []);

  const updateTableData = (isFilter) => {
    setTimeout(() => {
      tableRef?.current?.onChangeTable(isFilter);
    }, 100);
  };

  //--API REQUESTS--//
  const getBranchesList = async (query) => {
    try {
      const cartableId = queryq.get('cartableId');
      setLoading(true);
      let filter = toFilterVOS([...filters]);
      let queries = filterVOStoQueryStr(filter);
      let params = {};
      if (cartableId) {
        params['cartableId'] = cartableId;
      }
      (params['offset'] = query ? query?.pageNumber * query?.pageSize : page * size),
        (params['size'] = query ? query?.pageSize : size),
        (params['roles'] = ['OWNER']);
      params['orderType'] = 'desc';
      params = { ...params, ...queries };
      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };

      setFilterParams({ data, params });

      const res = await Services.getCartableRequestListRestfull(params);

      let list = [];

      list = generateData(res?.result, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });
      setLoading(false);

      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; //passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const changeStateOfBranch = async (selectedRow, changeStatusGroup) => {
    setLoadingBtn(true);

    try {
      if (Array.isArray(selectedRow)) {
        const filterBaseOnSameState = selectedRow.filter(
          (row) => row.branchInfoSrv.enable !== changeStatusGroup,
        );

        if (filterBaseOnSameState.length) {
          await SubsetServices.changeStateOfBranch({
            branchId: filterBaseOnSameState.map((row) => row.id),
            enable: changeStatusGroup,
          });
        }
      } else {
        await SubsetServices.changeStateOfBranch({
          branchId: [selectedRow.id],
          enable: !selectedRow.branchInfoSrv.enable,
        });
      }

      updateTableData(false);
    } catch (error) {
    } finally {
      setLoadingBtn(false);
      handleCloseDialog();
    }
  };

  //-- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    updateTableData(true);
  };

  const handleCloseDialog = () => {
    setDialog({ title: '', content: '', open: false, onAccept: () => null });
  };

  const ChangeStateActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={loadingBtn}
          name="بله"
          onClick={dialog?.onAccept}
        />

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };

  const hint = 'در این بخش میتوانید لیست درخواست ها را مشاهده کنید.';

  return (
    <PageContainer
      title="لیست درخواست ها"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.CARTABLE_REQUEST_LIST}
      className={classes.root}
    >
      {(actionsList['contentRequestCartblePage'] || actionsList['requestsGuildBtn']) && (
        <>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="end"
              alignItems="flex-end"
              style={{ marginBottom: 16 }}
            >
              <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          </Grid>
          {currencyText && (
            <TableComponents
              data={getBranchesList}
              columns={columns(navigate, setDialog, updateTableData, actionsList, currencyText)}
              isLoading={loading}
              ref={tableRef}
              onChange={(ps) => {
                setPage(ps?.pageNumber);
                setSize(ps?.pageSize);
                return getBranchesList(ps);
              }}
            />
          )}
        </>
      )}
      <SimpleDialog
        title={dialog?.title}
        content={dialog?.content}
        open={dialog?.open || false}
        actions={<ChangeStateActionBtn />}
      />
    </PageContainer>
  );
}
